export const DINOSAUR_ASCII = `
    __
   / _)
  ( ('>
   ) )
  /^/
 (_)
`;

export const DINOSAUR_ASCII_SMALL = `🦖`;

export const DINOSAUR_ASCII_TINY = `🦖`;